import React, { useState, useEffect } from "react";
import { InputText } from "primereact/inputtext";
import { Dropdown } from "primereact/dropdown";
import { RadioButton } from "primereact/radiobutton";
import { Button } from "primereact/button";
import { useFormik } from "formik";
import classNames from "classnames";
import { useDispatch, useSelector } from "react-redux";
import { handleGetRequest } from "../../../services/GetTemplate";
import { handlePostRequest } from "../../../services/PostTemplate";
import { handlePutRequest } from "../../../services/PutTemplate";
import { SetEditParserFlagAction, GetParserHeadDetailsAction, SetParserHeadDetailsToNullAction } from "../../../redux/actions/companyAction";
import ParserHeadDetails from "./ParserHeadDetails";
import ParserHead from "./ParserHead";
import AddEditParserHeadDetails from "./AddEditParserHeadDetails";
import * as Yup from "yup";

function AddEditParserHead() {
    const [loading, setloading] = useState(false);
    const [loadingIcon, setloadingIcon] = useState("pi pi-save");
    const [parserHeadOptions, setparserHeadOptions] = useState([]);
    const [parserHeadId, setparserHeadId] = useState("");
    const dispatch = useDispatch();

    const formData__Store = useSelector((state) => state.companySlice?.parserHeadDetailsForm);
    const editFlag__Store = useSelector((state) => state.companySlice?.parserHeadEditFlag);

    useEffect(() => {
        if (formData__Store !== undefined && formData__Store !== null && formData__Store?.length !== "" && formData__Store !== "") {
            fillParserHeadForm();
        }
    }, [formData__Store]); // eslint-disable-line

    useEffect(() => {
        if (editFlag__Store) {
            fillParserHeadForm();
        }
    }, [editFlag__Store, formData__Store]);

    const fillParserHeadForm = () => {
        const productId = { code: formData__Store?.tblProduct?.masterProductCode, description: formData__Store?.tblProduct?.masterProductName, id: formData__Store?.tblProduct?.productId?.toString(), longText: null, shortText: null };
        formik.setFieldValue("code", formData__Store?.code?.toString());
        formik.setFieldValue("description", formData__Store?.description?.toString());
        formik.setFieldValue("isActive", formData__Store?.isActive);
        formik.setFieldValue("productId", productId);
    };

    useEffect(() => {
        handleGetRequest("zbizgateway/lov/lovProduct/").then((res) => {
            setparserHeadOptions(res?.data);
        });
    }, []);

    const validationSchema = Yup.object().shape({
        productId: Yup.mixed().required("This field is required."),
        code: Yup.string()
            .required("This field is required.")
            .matches(/^[A-Za-z0-9 ]+$/, "Special Character are not allowed"),
        description: Yup.string().required("This field is required."),
    });

    const formik = useFormik({
        validationSchema: validationSchema,
        initialValues: {
            productId: "",
            code: "",
            description: "",
            isActive: "N",
        },

        onSubmit: async (data) => {
            setloading(true);
            setloadingIcon("pi pi-spin pi-spinner");
            data["productId"] = data?.productId?.id;

            if (editFlag__Store) {
                data["parserHeadId"] = formData__Store?.parserHeadId;
                await handlePutRequest(data, "/zbizgateway/nonFin/updateParserHead");
                await dispatch(GetParserHeadDetailsAction("zbizgateway/nonFin/getAllParsers"));
                dispatch(SetEditParserFlagAction(false));
                dispatch(SetParserHeadDetailsToNullAction());
            } else {
                const res = await handlePostRequest(data, "zbizgateway/nonFin/saveParserHead");
                dispatch(SetParserHeadDetailsToNullAction());
                setparserHeadId(res?.data?.parserHeadId);
                dispatch(GetParserHeadDetailsAction("zbizgateway/nonFin/getAllParsers"));
            }
            setloading(false);
            setloadingIcon("pi pi-save");
        },
    });
    const isFormFieldValid = (name) => !!(formik.touched[name] && formik.errors[name]);
    const getFormErrorMessage = (name) => {
        return isFormFieldValid(name) && <small className="p-error">{formik.errors[name]}</small>;
    };

    const handleCancel = (e) => {
        e.preventDefault();
        formik.resetForm();
        dispatch(SetEditParserFlagAction(false));
        dispatch(SetParserHeadDetailsToNullAction());
    };

    const handleParserHeadId = () => {
        setparserHeadId("");
    };

    return (
        <div className="card Card__Round">
            <div className="Form__Header">
                <h1>Parser Head</h1>
            </div>
            <form onSubmit={formik.handleSubmit} className="p-fluid p-mt-2">
                <div className="p-fluid p-formgrid p-grid">
                    <div className="p-field p-col-12 p-md-3">
                        <div className="p-field">
                            <label htmlFor="productId" className={classNames({ "p-error": isFormFieldValid("productId") }, "Label__Text")}>
                                Product<span className="Label__Required">*</span>
                            </label>
                            <Dropdown
                                id="productId"
                                placeholder="Enter Product"
                                options={parserHeadOptions}
                                optionLabel="description"
                                name="productId"
                                value={formik.values.productId}
                                onChange={formik.handleChange}
                                className={classNames({ "p-invalid": isFormFieldValid("productId") }, "Dropdown__Round")}
                            />
                            {getFormErrorMessage("productId")}
                        </div>
                    </div>
                    <div className="p-field p-col-12 p-md-3">
                        <div className="p-field">
                            <label htmlFor="code" className={classNames({ "p-error": isFormFieldValid("code") }, "Label__Text")}>
                                Code<span className="Label__Required">*</span>
                            </label>
                            <InputText id="code" placeholder="Enter Code" name="code" value={formik.values.code} onChange={formik.handleChange} className={classNames({ "p-invalid": isFormFieldValid("code") }, "Input__Round")} />

                            {getFormErrorMessage("code")}
                        </div>
                    </div>
                    <div className="p-field p-col-12 p-md-3">
                        <div className="p-field">
                            <label htmlFor="description" className={classNames({ "p-error": isFormFieldValid("description") }, "Label__Text")}>
                                Description<span className="Label__Required">*</span>
                            </label>
                            <InputText id="description" placeholder="Enter Description" name="description" value={formik.values.description} onChange={formik.handleChange} className={classNames({ "p-invalid": isFormFieldValid("description") }, "Input__Round")} />

                            {getFormErrorMessage("description")}
                        </div>
                    </div>
                    <div className="p-field p-col-12 p-md-3">
                        <label htmlFor="isActive" className="Label__Text">
                            Active
                        </label>
                        <div className="Radio__Btn">
                            <div className="p-field-radiobutton">
                                <RadioButton inputId="isActive" name="isActive" value={"N"} onChange={formik.handleChange} checked={formik.values.isActive === "N"} />
                                <label htmlFor="isActive">No</label>
                            </div>
                            <div className="p-field-radiobutton">
                                <RadioButton inputId="isActive" name="isActive" value={"Y"} onChange={formik.handleChange} checked={formik.values.isActive === "Y"} />
                                <label htmlFor="isActive">Yes</label>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="Down__Btn">
                    <Button label="Cancel" onClick={(e) => handleCancel(e)} className="Btn__Transparent" />
                    <Button type="submit" disabled={loading} icon={loadingIcon || ""} iconPos="right" label={editFlag__Store ? "Edit" : "Add"} className="Btn__Dark" />
                </div>
            </form>
            <AddEditParserHeadDetails parserHeadId={parserHeadId} handleParserHeadId={handleParserHeadId} />
            <ParserHeadDetails />
            <ParserHead />
        </div>
    );
}

export default AddEditParserHead;
